import { render } from "./TransferModal.vue?vue&type=template&id=e8598f64&ts=true"
import script from "./TransferModal.vue?vue&type=script&lang=ts"
export * from "./TransferModal.vue?vue&type=script&lang=ts"

import "./TransferModal.vue?vue&type=style&index=0&id=e8598f64&lang=scss"

import exportComponent from "/home/jenkins/agent/workspace/git_node_build_images_push_anjinq_test/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__